import { render, staticRenderFns } from "./CoHeader.vue?vue&type=template&id=4b29b13b&scoped=true&"
import script from "./CoHeader.vue?vue&type=script&lang=js&"
export * from "./CoHeader.vue?vue&type=script&lang=js&"
import style0 from "./CoHeader.vue?vue&type=style&index=0&id=4b29b13b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b29b13b",
  null
  
)

export default component.exports